import {get_nested} from "../../../services/JsonHandler";
import SystemZoomedPictureDialog from "../../dialogs/SystemZoomedPictureDialog";
import {
    displayLandscapeOrSquare, displayPortrait
} from "../../../controllers/flashScreens/questionsStepScreen/QuestionPictureController";
import SystemQuestionPicture from "../../images/SystemQuestionPicture";
import SystemQuestionKnowledge from "../SystemQuestionKnowledge";
import SystemOptionsCard from "../../cards/SystemOptionsCard";
import {useState} from "react";
import FlashCorrectionQuestionQueryText from "../../texts/courses/flash/FlashCorrectionQuestionQueryText";
import FlashCorrectionOptionsLayout from "../../layouts/courses/flash/FlashCorrectionOptionsLayout";

export default function PreviewQuestionCorrectionContent({question}) {
    // Used in PreviewFlashQuestionContent to display

    // PROPERTIES
    // ---- Modal
    const [isPictureModalOpen, setIsPictureModalOpen] = useState(false)
    // ---- Question
    const questionQuery = get_nested(['query'], question, null)
    const questionKnowledge = get_nested(['levelA', 'levelAKnowledge'], question, null)
    const questionPicture = get_nested(['questionPicture'], question, null)
    const questionPictureUrl = get_nested(['questionPicture', 'filePath'], question, null)
    const questionPictureRatio = get_nested(['questionPicture', 'ratio'], question, null)

    // BUILD
    return (
        <div className={"w-full grow flex flex-col items-center"}>
                {/** MODAL */}
                <SystemZoomedPictureDialog open={isPictureModalOpen}
                                           handleClose={() => setIsPictureModalOpen(false)}
                                           pictureUrl={questionPictureUrl}
                                           pictureRatio={questionPictureRatio}/>
                {/** CORE */}
                <FlashCorrectionQuestionQueryText query={questionQuery} />
                {/*<SystemQuestionPicturePlaceholder pictureRatio={PictureRatio.LANDSCAPE}*/}
                {/*                                  isForMobile={false} />*/}
                {displayLandscapeOrSquare(questionPicture, questionPictureUrl, questionPictureRatio)
                    ? <SystemQuestionPicture pictureUrl={questionPictureUrl}
                                             pictureRatio={questionPictureRatio}
                                             isForMobile={false}
                                             openZoom={() => setIsPictureModalOpen(true)}/>
                    : null}
                <SystemQuestionKnowledge knowledge={questionKnowledge}/>
                <FlashCorrectionOptionsLayout>
                    {displayPortrait(questionPicture, questionPictureUrl, questionPictureRatio)
                        ? <SystemQuestionPicture pictureUrl={questionPictureUrl}
                                                 pictureRatio={questionPictureRatio}
                                                 isForMobile={false}
                                                 openZoom={() => setIsPictureModalOpen(true)}/>
                        : null}
                    {/*<SystemQuestionPicturePlaceholder pictureRatio={PictureRatio.PORTRAIT}*/}
                    {/*                                  isForMobile={false} />*/}
                    <SystemOptionsCard question={question}/>
                </FlashCorrectionOptionsLayout>
        </div>
    );
}